import React, {useEffect} from 'react';
import {Review} from "../../../services/api/ReviewService";
import Avatar from "../../../components/Avatar";
import StarIcon from "../../../icons/StarIcon";
import {IconSize} from "../../../services/IconConstants";
import CalendarIcon from "../../../icons/CalendarIcon";
import {Badge, Button, Spinner} from "react-bootstrap";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import ErrorText from "../../../components/ErrorText";
import {useAppDispatch} from "../../../services/store/store";
import {loadNextPageReviews, loadReviews} from "../../../services/store/reducers/reviews/async_actions";
import {
    handleFilterSidePanelOpen,
    handleToggleCaddieFilter,
    handleToggleStarFilter
} from "../../../services/store/reducers/reviews/slice";
import UserIcon from "../../../icons/UserIcon";
import CrossIcon from "../../../icons/CrossIcon";

interface Props {
}

const ReviewList = ({}: Props) => {

    const { selectedClub } = handicaddieSelector((state) => state.clubs)
    const { atMax, loading, errMsg, reviews } = handicaddieSelector((state) => state.review.reviewFeed)
    const { stars, caddie, date } = handicaddieSelector((state) => state.review.filters)
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(loadReviews())
    }, [selectedClub])

    useEffect(() => {
        dispatch(loadReviews())

        const handleScroll = async () => {
            const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
            if (scrollTop + clientHeight >= scrollHeight - 20) {
                dispatch(loadNextPageReviews())
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <div className={"reviewList-reviews-container"}>
                <div className={"reviewList-reviews-row"}>
                    <div className={"reviewList-row-container"} style={{ flexDirection: 'column' }}>
                        <div className={"explorer-filters-btn"}>
                            <Button variant={'outline-primary'}
                                    onClick={() => dispatch(handleFilterSidePanelOpen(true))}>
                                Filters
                            </Button>
                        </div>
                        <div className={"explorer-filters-pills-container"}>
                            <div className={"explorer-filters-pill"} onClick={() => dispatch(handleFilterSidePanelOpen(true))}>
                                <CalendarIcon size={IconSize.sm} />
                                {date.from} - {date.to}
                            </div>
                            {stars.map((star) => (<div className={"explorer-filters-pill"}
                                                       onClick={() => {
                                                           dispatch(handleToggleStarFilter(star));
                                                           dispatch(loadReviews());
                                                       }}>
                                <CrossIcon size={IconSize.xs} />
                                <StarIcon size={IconSize.sm} active={true} />
                                {star}
                            </div>))}
                            {caddie.map((c) => (<div className={"explorer-filters-pill"}
                                onClick={() => {
                                    dispatch(handleToggleCaddieFilter(c));
                                    dispatch(loadReviews());
                                }}>
                                <CrossIcon size={IconSize.xs} />
                                <UserIcon size={IconSize.sm} />
                                {c.displayName}
                            </div>))}
                        </div>
                    </div>
                </div>

                <div className={"reviewList-reviews-row"}>
                {reviews.map((review: Review) => (
                        <div className={"reviewList-row-container"} key={review.id}>
                            <div className={"reviewList-review-section-container reviewList-caddie-container"}>
                                <div>
                                    <Avatar size={'smd'} user={review.caddieUser?.id} />
                                </div>
                                <div>
                                    <h6 className={"reviewList-review-caddieName"}>{review.caddieUser ? review.caddieUser.displayName : 'Unknown Caddie'}</h6>
                                </div>
                            </div>
                            <div className={"reviewList-review-section-container reviewList-review-container"}>
                                <div className={"reviewList-review-section-heading-container"}>
                                    <div>
                                        {[...Array(5)].map((_, idx) => {
                                            return <StarIcon
                                                key={idx}
                                                size={IconSize.sm}
                                                active={review.rating > 0 && review.rating >= (idx + 1)} />
                                        })}
                                    </div>

                                    <div>
                                        <CalendarIcon size={IconSize.sm}/>
                                        <span className={"reviewList-review-header-created-txt"}>{review.created}</span>
                                    </div>
                                </div>
                                <div>
                                    {review.message && <p>{review.message}</p>}
                                    {!review.message && <p><i>No comment left.</i></p>}
                                    {review.attributes.map((attribute) => (
                                        <Badge className={"reviewList-attribute"}>{attribute}</Badge>
                                    ))}
                                </div>

                                <div className={"reviewList-review-footer"}>
                                    {review && review.author && <div>
                                        <span><i>Review left by:</i> {review.author.displayName}</span>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {reviews && reviews.length > 0 && atMax && <div className={"reviewList-row-container reviewList-loading-row"}>
                    <i>You've reached the end of the reviews.</i>
                </div>}
                {loading && <div className={"reviewList-row-container reviewList-loading-row"}>
                    <Spinner animation={'border'} />
                </div>}
                {errMsg && <div className={"reviewList-row-container reviewList-loading-row"}>
                    <ErrorText>{errMsg}</ErrorText>
                </div>}
                {(!reviews || reviews.length === 0) && <div className={"reviewList-row-container reviewList-loading-row"}>
                    <i>No reviews to display.</i>
                </div>}
            </div>
        </>
    )
}

export default ReviewList;